import { render, staticRenderFns } from "./ReceivingDispatcher.vue?vue&type=template&id=1c357ef8&scoped=true&"
import script from "./ReceivingDispatcher.vue?vue&type=script&lang=js&"
export * from "./ReceivingDispatcher.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingDispatcher.vue?vue&type=style&index=0&id=1c357ef8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c357ef8",
  null
  
)

export default component.exports